import { createModule } from '@vue-storefront/core/lib/module'
import { IdleActivity, IDLE_ACTIVITY_DEFAULTS } from './lib/IdleActivity'

export const KEY = 'idle-activity'

export { IdleActivity, IDLE_ACTIVITY_DEFAULTS }
export * from './types'

/**
 * Multi-tab idle activity module.
 *
 * Replaces the vendored idlejs helper under cache-tools. Consumers construct
 * IdleActivity and call start()/stop() themselves (e.g. SSO login-as-customer).
 *
 * @example
 * import { IdleActivity } from 'theme/modules/idle-activity'
 *
 * const idle = new IdleActivity()
 *   .withStorageKey('sso-last-activity')
 *   .within(60) // 60 minutes
 *   .whenEnabled(() => localStorage.getItem('login-as-customer-session') === '1')
 *   .do(() => store.dispatch('user/logout', { silent: false }))
 *   .start()
 */
export const IdleActivityModule = createModule({
  key: KEY
})
